import { AgentApiPath, useHallApi } from '@99fun-agent/hooks'
import { defineStore } from 'pinia'

export const useIncomesStore = defineStore('incomesStore', () => {
  const { authGet } = useHallApi()
  const reqGetIncomesList = async () => {
    const r = await authGet<IIncomesReply>(
      AgentApiPath.GetIncomes,
      {},
      {
        showErrorCodeTip: true,
        showLoading: true
      }
    )

    return r.data
  }
  const reset = () => {}
  return { reset, reqGetIncomesList }
})

export interface IIncomesReply {
  incomes: IIncomeInfo[]
  pendingSettlementAmount:number
}

export enum AgentDividendBillStatus {
  /**
   * 进行中
   */
  InProgress = 0,
  /**
   * 待审核
   */
  PendingReview = 1,
  /**
   * 审核成功
   */
  Reviewed = 2,
  /**
   * 审核失败
   */
  ReviewFailed = 3,
  /**
   * 待结算
   */
  PendingSettlement = 4,
  /**
   * 已结束
   */
  Finished = 9
}

export interface IIncomeInfo {
  month: string
  phase: number
  activeUserCount: number
  netEarningAmount: number
  bonusAmount: number
  productFeeAmount: number
  dividendRatio: number
  dividendAmount: number
  status: AgentDividendBillStatus
}
